// extracted by mini-css-extract-plugin
export var tosLink = "_e1-0";